import { useRef, useEffect } from "react";

/**
 * Custom hook to automatically scroll to results section when results are generated
 * @param {any} results - The results state to watch
 * @returns {Object} - Ref to attach to results container
 */
export function useScrollToResults(results) {
  const resultsRef = useRef(null);

  useEffect(() => {
    if (!results || !resultsRef.current) return undefined;

    // Small delay to ensure DOM has updated
    const timer = setTimeout(() => {
      resultsRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);

    // THE TIMER MUST NOT OUTLIVE THE COMPONENT (2026-08-19). Nothing
    // cancelled it, so a page unmounted inside its 100 ms window left a
    // callback scheduled against a component that no longer exists.
    //
    // The failure it caused is worth recording, because it fired
    // somewhere other than where it lived : the callback lands on
    // whatever is running when the timer expires. Under test that meant
    // a Cloud Build failure attributed to a chain-analyzer change, in a
    // Domain Control Validation (DCV) page test, thrown from a hook
    // neither of them mentions - and only on a machine slow enough for
    // the timer to expire before teardown. Every gate was green on a
    // faster one.
    return () => clearTimeout(timer);
  }, [results]);

  return resultsRef;
}
